import apiClient from './client';

export interface AiUsageLog {
  id: number;
  feature: string;
  feature_label: string;
  model: string;
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
  cost_usd: number;
  duration_ms: number;
  status: 'success' | 'failed';
  created_at: string;
}

export interface AiUsageStats {
  total_calls: number;
  total_tokens: number;
  total_cost_usd: number;
  calls_by_feature: Record<string, { calls: number; tokens: number; cost_usd: number }>;
  period_days: number;
}

export interface PaginatedAiUsage {
  data: AiUsageLog[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const aiUsageApi = {
  list: (page = 1, perPage = 25): Promise<PaginatedAiUsage> =>
    apiClient.get('/ai/usage', { params: { page, per_page: perPage } }).then(r => r.data),

  stats: (days = 30): Promise<{ data: AiUsageStats }> =>
    apiClient.get('/ai/usage/stats', { params: { days } }).then(r => r.data),
};
